module.exports = __webpack_public_path__ + "media/2.7e509b72.wav";